var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, runInAction, when } from 'mobx';
import { LoadStatus, PlayStatus } from '../../../learnware/LearnwareEnums';
import { runtime } from '../../../runtime/Runtime';
export class AudioIntentHandler {
    intent;
    constructor(intent) {
        makeObservable(this);
        this.intent = intent;
        const preloadHowl = this.intent.snd.sndHowl;
    }
    errorText = '';
    async setIntentLoadStatusWhenHowlIsLoaded() {
        await when(() => this.intent.snd.sndHowl.isLoaded);
        if (this.intent.loadStatus === LoadStatus.Loading) {
            runInAction(() => {
                this.intent.loadStatus = LoadStatus.Ready;
            });
        }
    }
    async play() {
        await runtime.solidBrowserRuntime.browserIncludes.includeJSFileOnce('/lib/howler/dist/howler.core.min.js');
        this.setIntentLoadStatusWhenHowlIsLoaded(); // not not wait until load
        runInAction(() => {
            this.intent.playStatus = PlayStatus.Go;
        });
        this.howl.volume(this.intent.volume);
        this.howlId = this.howl.play();
        setTimeout(action(() => {
            if (this.intent.playStatus === PlayStatus.Go) {
                this.intent.playStatus = PlayStatus.Error;
                console.error('starting of howl failed', this.intent);
            }
        }), 3000);
        runInAction(() => {
            this.intent.snd.sndHowl.howlIntents.set(this.howlId, this);
        });
    }
    get howl() {
        return this.intent.snd.sndHowl.howl;
    }
    howlId;
    intervalId;
    onPlay() {
        this.intent.playStatus = PlayStatus.Playing;
        this.intent.startDate = runtime.runtimeClock.currentDate;
        if (!this.intervalId) {
            this.intervalId = setInterval(this.checkPosition, 500); // 500
        }
    }
    noMoreCheckPosition() {
        if ([PlayStatus.Playing, PlayStatus.Go, PlayStatus.Pending].includes(this.intent.playStatus)) {
            this.intent.playStatus = PlayStatus.Aborted;
        }
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    lastPosition = -1;
    checkPosition() {
        if (this.intent.questionId !== this.intent.app.questionId) {
            this.noMoreCheckPosition();
            return;
        }
        if ([PlayStatus.Ended, PlayStatus.Aborted, PlayStatus.Error].includes(this.intent.playStatus)) {
            this.noMoreCheckPosition();
            return;
        }
        const position = this.howl.seek();
        if (position === this.lastPosition && this.intent.playStatus === PlayStatus.Playing) {
            this.intent.playStatus = PlayStatus.Aborted;
            this.errorText = 'no progress in checkPosition';
            console.log(this.errorText);
        }
        if (this.intent.playStatus === PlayStatus.Paused && position !== this.lastPosition) {
            this.intent.playStatus = PlayStatus.Playing;
        }
        this.lastPosition = position;
        this.intent.progressInSeconds = position;
    }
    onEnd() {
        this.intent.playStatus = PlayStatus.Ended;
        this.intent.endDate = runtime.runtimeClock.currentDate;
    }
    pause() {
        this.howl.pause();
    }
    stop() {
        this.howl.stop();
    }
    mute() {
        this.howl.mute();
    }
    volume() {
        this.howl.volume();
    }
    rate() {
        this.howl.rate();
    }
    seek() {
        this.howl.seek();
    }
    loop() {
        this.howl.loop();
    }
}
__decorate([
    action.bound
], AudioIntentHandler.prototype, "setIntentLoadStatusWhenHowlIsLoaded", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "play", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "onPlay", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "checkPosition", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "onEnd", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "pause", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "stop", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "mute", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "volume", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "rate", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "seek", null);
__decorate([
    action.bound
], AudioIntentHandler.prototype, "loop", null);
